export default {
  currentUser: {
    id: '',
    name: '',
    username: '',
    avatar:''
  }
}
